"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockCourseDisplayNames = {
    course_display_names: {
        java: 'Java',
        frontend: 'Front End Security Basics',
        http: 'HTTP Security Principles',
        hacking_headlines: 'Hacking Headlines',
        dotnet: '.NET',
        scala: 'Scala',
        python: 'Python Django',
        android: 'Android',
    },
};
exports.default = mockCourseDisplayNames;
